import { ISubscription, createSubscription, updateSubscription } from "@/services/subscription/subscription.service"
import { DatePicker, Form, Input, Modal, ModalProps, Select } from "antd"
import { useEffect } from "react"
import ReactDOM from "react-dom"
import { useRequest } from "ahooks"
import { getPlans } from "@/services/checkout.service"
import { UserSelect } from "../Components/UserSelect/UserSelect"
import dayjs from "dayjs"

interface SubscriptionModalProps extends ModalProps {
  subscription?: ISubscription
  onSuccess: () => void
}

const billingFrequencyOptions = [{value: 'MONTH', label: 'Month'}, {value: 'YEAR', label: 'Year'}]
const statusOptions = [{value: 'active', label: 'Active'}, {value: 'inactive', label: 'Inactive'}]

export function SubscriptionModal(props: SubscriptionModalProps) {
  const { onSuccess, onCancel, subscription} = props
  const [form] = Form.useForm()
  const {data: plans} = useRequest(async () => {
    const plans = await getPlans()
    return plans.map((item) => ({value: item.name, label: item.name}))
  })


  useEffect(() => {
    if (!subscription) {
      form.setFieldsValue({
        currency: 'usd'
      })
    } else {
      const initData = {
        ...subscription,
        subscriptionStart: dayjs(subscription.subscriptionStart),
        subscriptionEnd: dayjs(subscription.subscriptionEnd)
      }
      form.setFieldsValue(initData)
    }
  }, [subscription])

  const userOptions = subscription ? [{value: subscription.userId, label: subscription.email}] : []

  return <Modal
      title={subscription ? 'Edit Subscription' : 'Create Subscription'}
      width={600}
      open={true}
      onCancel={onCancel}
      onOk={() => form.submit()}
    >
      <Form
        form={form}
        onFinish={async (values) => {
          const body = {
            ...values,
            subscriptionStart: values.subscriptionStart.valueOf(),
            subscriptionEnd: values.subscriptionEnd.valueOf()
          }
          if (subscription) {
            await updateSubscription(body, subscription.id)
          } else {
            await createSubscription(body)
          }
          onSuccess()
        }}
        className="mt-4"
      >
        <Form.Item label='User' name='userId' rules={[{ required: true, message: 'Please select a user' }]}>
          
          <UserSelect defaultOptions={userOptions} />
        </Form.Item>
        <Form.Item label='Plan' name='plan' rules={[{ required: true, message: 'Please select a plan' }]}>
          <Select options={plans} />
        </Form.Item>
        <Form.Item label='Billing Frequency' name='billingFrequency' rules={[{ required: true, message: 'Please select a Billing Frequency' }]}>
          <Select options={billingFrequencyOptions} />
        </Form.Item>
        <Form.Item label='Currency' name='currency' rules={[{ required: true, message: 'Please select a currency' }]}>
          <Select>
            <Select.Option value={'usd'}>USD</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item label='Status' name='status' rules={[{ required: true, message: 'Please select a status' }]}>
          <Select options={statusOptions}/>
        </Form.Item>
        <Form.Item label='Start Time' name='subscriptionStart' rules={[{ required: true, message: 'Please select a currency' }]}>
          <DatePicker />
        </Form.Item>
        <Form.Item label='End Time' name='subscriptionEnd' rules={[{ required: true, message: 'Please select a currency' }]}>
          <DatePicker />
        </Form.Item>
        <Form.Item label='Stripe Id' name='stripeId'>
          <Input type='text' />
        </Form.Item>
      </Form>
    </Modal>
}

SubscriptionModal.show = (props: SubscriptionModalProps) => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const clean = () => {
    ReactDOM.unmountComponentAtNode(div)
    div.remove()
  }

  ReactDOM.render(
    <SubscriptionModal
      {...props}
      onCancel={(e) => {
        props.onCancel?.(e)
        clean()
      }}
      onSuccess={() => {
        props.onSuccess?.()
        clean()
      }}
    />,
    div
  )
}